module.exports = __webpack_public_path__ + "static/media/canvas_fabric_active.e61705c0.svg";